module.exports = __webpack_public_path__ + "img/9.cd512a6e.png";